<div class="data-area">
    <table class="table table-hover table-inline-edit">
        <thead class="thead-light">
            <tr>
                <th width="60%">Species</th>
                <th class="text-right">Amount</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr *ngIf="miscAmount !== 0">
                <td>Miscellaneous</td>
                <td class="text-right">{{ miscAmount }}</td>
                <td class="table-button"></td>
            </tr> -->
            <tr *ngFor="let item of areaTreeSpecies">
                <td>{{item.species}}</td>
                <td  class="text-right">{{item.count}}</td>
                <td class="table-button vertical-middle">
                    <a class="edit" (click)="openModal(item)" title="Edit"><i class="icon-note"></i></a>

                    <a class="delete" (click)="delete(item)" title="Delete"><i class="icon-trash"></i></a>
                </td>
            </tr>
            <tr>
                <td><h5>Total</h5></td>
                <td class="text-right"><h5>{{ totalSpeciesInArea() }}</h5></td>
                <td class="table-button"></td>
            </tr>
        </tbody>
    </table>
</div>

<app-confirm-delete-modal-component #confirmDeleteModal></app-confirm-delete-modal-component>
